import React from 'react';

import { store } from '../utils/redux/store';
import _ from 'lodash';

const GetProfile = (key) => {
  const state = store.getState();
  const customerData = state.customerProfileReducer;
  const authenData = state.authenReducer;

  //console.log('state variable', state);

  const profile = {
    customerId: _.get(customerData, 'customerId'),
    customerName: _.get(customerData, 'comtomerName'),
    customerCode: _.get(customerData, 'comCode'),
    customerRefId: _.get(authenData, 'customerRefId'),
    username: _.get(customerData, 'username'),
    phone: _.get(customerData, 'phone'),
    accessToken: authenData,
  };

  return profile[key];
};

export default GetProfile;
